import { render } from "./AssignUserRoleOnBehalfOfModal.vue?vue&type=template&id=b197a7d4&ts=true"
import script from "./AssignUserRoleOnBehalfOfModal.vue?vue&type=script&lang=ts"
export * from "./AssignUserRoleOnBehalfOfModal.vue?vue&type=script&lang=ts"

import "./AssignUserRoleOnBehalfOfModal.vue?vue&type=style&index=0&id=b197a7d4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__